// extracted by mini-css-extract-plugin
export default {"container":"error_container__2AW0b","title":"error_title__3NbD9","description":"error_description__1IZ2F"};